import { ClearRounded } from "@mui/icons-material";
import { Box, Button, Dialog, DialogActions, IconButton, Stack, Typography } from "@mui/material";
import RenderInputField from "components/PimDashboard/CommonComponents/RenderInputField/RenderInputField";
import { addOrEditModelAction } from "components/PimDashboard/data";
import { getColDefaultValue } from "components/PimDashboard/data";
import { statusOptions, selectOptionsKeyName } from "data/globalData";
import { useState } from "react";

const CreateModal = ({ modal, setModal, selectedObj, columns, callbackFun }) => {
	const defFields = (() => {
		let obj = {};
		columns?.forEach((row) => {
			obj[row?.key] = getColDefaultValue(row);
		});
		return obj;
	})();
	const [updatedData, setUpdatedData] = useState(selectedObj);

	const handleModalclose = () => {
		setModal(false);
	};

	const handleFormSubmit = async (e) => {
		e.preventDefault();

		if (typeof callbackFun === "function") callbackFun(updatedData);
	};
	return (
		<Dialog
			maxWidth={{ xs: "sm", xl: "lg" }}
			fullWidth
			open={modal}
			onClose={handleModalclose}
			component="form"
			onSubmit={handleFormSubmit}>
			<Box p={2}>
				<Box display="flex" justifyContent="space-between" alignItems="center">
					<Typography variant="h6">Create Projection </Typography>
					<Box>
						<IconButton onClick={handleModalclose}>
							<ClearRounded />
						</IconButton>
					</Box>
				</Box>
				<Stack spacing={1} width="100%">
					{" "}
					<Box display="flex" columnGap={"10px"} rowGap="10px" flexWrap="wrap" width="100%">
						{columns?.map((row) => {
							return (
								<RenderInputField
									column={row}
									data={updatedData}
									setData={setUpdatedData}
									width="24%"
									selectOptObjName={selectOptionsKeyName}
								/>
							);
						})}
					</Box>
				</Stack>

				<DialogActions sx={{ pt: 2 }}>
					<Button variant="outlined" sx={{ justifySelf: "center" }} onClick={handleModalclose}>
						Cancel
					</Button>
					<Button variant="contained" sx={{ justifySelf: "center" }} type="submit">
						Save
					</Button>
				</DialogActions>
			</Box>
		</Dialog>
	);
};

export default CreateModal;
